import { IApiSmpPage } from "@smp/api";
import { IUiAvatarProps, UiBadge, UiSocialIcon } from "@smp/ui";
import { REACT_APP__IS_FOREIGN } from "@smp/utils";
import clsx from "clsx";
import { ComponentProps } from "react";

import { AvatarProxified } from "../avatar_proxified";
import classesLocal from "./avatar_social.module.css";

type AvatarProxifiedProps = ComponentProps<typeof AvatarProxified>;

export const AvatarSocial = ({
  medium,
  isMediumOnLeft,
  hideBadge,
  classes,
  ...props
}: Omit<AvatarProxifiedProps, "src" | "classes"> & {
  src?: IUiAvatarProps["src"] | null;
  medium: IApiSmpPage["medium"];
  isMediumOnLeft?: boolean;
  hideBadge?: boolean;
  classes?: AvatarProxifiedProps["classes"] & {
    badge?: string;
  };
}) => {
  const { badge: classBadge, ...avatarClasses } = classes || {};

  return (
    <UiBadge
      anchorOrigin={{
        horizontal: isMediumOnLeft ? "left" : "right",
        vertical: "top",
      }}
      badgeContent={
        !hideBadge ? (
          <UiSocialIcon
            classes={{
              icon: classesLocal.icon,
              root: clsx(
                classesLocal.root,
                classesLocal[`root_medium_${medium}`],
              ),
            }}
            isDisplayingIconDangerous={!REACT_APP__IS_FOREIGN}
            medium={medium}
            size="small"
          />
        ) : undefined
      }
      overlap="circular"
      className={classBadge}
    >
      <AvatarProxified classes={avatarClasses} {...props} />
    </UiBadge>
  );
};
